import React from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'
import {getDomainConfig} from '~/domains'

const AffiliationNotice = () => {
  const {language, domain, locale, featureFlags} = useRouteLoaderData('root') as RootLoaderResponse
  const {camelCaseUrl} = getDomainConfig(domain, locale)
  const translations = getTranslation(language)

  return (
    <div className="flex min-h-20 w-full flex-col items-center justify-center gap-2 bg-neutral-50 px-8 text-center font-light leading-4 text-neutral-500 tablet:min-h-24 tablet:px-3 tablet:py-2">
      <span>{translations.affiliationNotice(camelCaseUrl)}</span>
      {featureFlags?.showCcpaAndSharingPolicy ? <span>{translations.ShareDisclaimer}</span> : null}
    </div>
  )
}

export default AffiliationNotice
